import { render, staticRenderFns } from "./WarningsComponent.vue?vue&type=template&id=7afa1186"
import script from "./WarningsComponent.vue?vue&type=script&lang=ts"
export * from "./WarningsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports